import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import { isAuth } from "../../actions/auth";

const Admin = (props) => {
  const { history, children } = props;
  useEffect(() => {
    if (!isAuth()) {
      history.replace(`/staff/signin`);
    } else {
      // Removed redirect logic - all authenticated users can access admin dashboard

      // Valid Admin/Staff roles (role 1) stay here
    }
  }, []);
  return <React.Fragment>{children}</React.Fragment>;
};
export default withRouter(Admin);
